/**
 * Where each door lives, from wherever the visitor is standing.
 *
 * Prod: the student app at `buzzbrain.ai`, the teacher app at
 * `teacher.buzzbrain.ai`. Dev: the same on `hindaun.in`. Local web apps proxy to
 * the dev backend; on a worktree's port pair they point at each other, and
 * otherwise at the dev sites.
 */

function host(): string {
  return typeof window === 'undefined' ? 'buzzbrain.ai' : window.location.hostname;
}

function isDevHost(h: string): boolean {
  return h.endsWith('hindaun.in') || h === 'localhost' || h === '127.0.0.1' || h.endsWith('.local');
}

/**
 * On localhost, the sibling app on the same worktree's ports: student `5xyN`
 * and teacher `7xyN` (CLAUDE.md), so a local preview links to local pages.
 */
function localSibling(first: '5' | '7'): string | null {
  if (typeof window === 'undefined' || window.location.hostname !== 'localhost') return null;
  const port = window.location.port;
  if (!/^[57]\d{3}$/.test(port)) return null;
  return `${window.location.protocol}//localhost:${first}${port.slice(1)}`;
}

/** The teacher site's origin: landing page at `/teachers`, sign-in at `/login`. */
export function teacherSiteUrl(): string {
  return localSibling('7') ?? (isDevHost(host()) ? 'https://teacher.hindaun.in' : 'https://teacher.buzzbrain.ai');
}

/** The student site's origin: the hub at `/`, sign-in at `/login`. */
export function studentSiteUrl(): string {
  return localSibling('5') ?? (isDevHost(host()) ? 'https://hindaun.in' : 'https://buzzbrain.ai');
}
